module.exports = __webpack_public_path__ + "img/avatar-s-17.2a01b307.jpg";